import Card from "../../components/Card";
import Layout from "../layout";
import Results from './Results';


export default function ResultsPage() {
  return (
    <Layout>
      <Card>
        <Results />
      </Card>
    </Layout>
  );
}
